"use strict";

var app = angular.module('app');

app.filter('taxPercentage', function(){
   return function(tax){
       if(tax == 0){
           return '';
       }

       return tax+"%";
   }
});
